import muvika from "./muvikaApiClient";
import dayjs from 'dayjs';
import TestService from './testing';
import { encode, decode } from '@frsource/base64';
import { Base64 } from 'js-base64';
import { sha256 } from 'js-sha256';
import utf8 from "utf8";
import { Device } from '@capacitor/device';
import { MailIcon } from '@mui/icons-material/Mail';
import { Capacitor } from '@capacitor/core';
import { getOS } from './os';
import songbookStore from './../stores/songbook';
import sessionStore from './../stores/session';
import version from './../version';
import { v4 as uuidv4 } from 'uuid';
import muvikaAttrs from './../attrs';
import accountStore from "../stores/account";

(function () {
  if (!(escape && unescape)) {
    var escapeHash = {
      _: function (input) {
        var ret = escapeHash[input];
        if (!ret) {
          if (input.length - 1) {
            ret = String.fromCharCode(input.substring(input.length - 3 ? 2 : 1));
          }
          else {
            var code = input.charCodeAt(0);
            ret = code < 256
              ? "%" + (0 + code.toString(16)).slice(-2).toUpperCase()
              : "%u" + ("000" + code.toString(16)).slice(-4).toUpperCase();
          }
          escapeHash[ret] = input;
          escapeHash[input] = ret;
        }
        return ret;
      }
    };
    escape = escape || function (str) {
      return str.replace(/[^\w @\*\-\+\.\/]/g, function (aChar) {
        return escapeHash._(aChar);
      });
    };
    unescape = unescape || function (str) {
      return str.replace(/%(u[\da-f]{4}|[\da-f]{2})/gi, function (seq) {
        return escapeHash._(seq);
      });
    };
  }
})();

class MuvikaService {

  requestId = sessionStore ? sessionStore.getState().requestCount : 0;
  clientHash = Capacitor.isNativePlatform() ? muvikaAttrs.nativeClientHash : muvikaAttrs.webClientHash;
  deviceId = this.getDeviceId();
  deviceName = Capacitor.isNativePlatform() ? "" : window.navigator.userAgent;
  deviceModel = Capacitor.isNativePlatform() ? "" : "";
  softwareName = Capacitor.isNativePlatform() ? "muvikaapp" : "muvikaweb";
  softwareVersion = this.getVersion();
  clientVersion = this.getVersion();
  osName = Capacitor.isNativePlatform() ? Capacitor.getPlatform() : getOS();
  osVersion = "";

  getVersion() {
    let versionSplitted = version.split(" ");
    return versionSplitted[0];
  }

  getDeviceId() {
    const saved = localStorage.getItem(muvikaAttrs.service + "-device-id");
    const initialValue = JSON.parse(saved);
    if (initialValue) {
      return initialValue;
    } else {
      let newId = uuidv4();
      localStorage.setItem(muvikaAttrs.service + "-device-id", JSON.stringify(newId));
      return newId;
    }
  }

  base64urlEncode(str) {
    /* return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode('0x' + p1);
      })); */
    /* var bytes = utf8.encode(str);
    return base64.encode(bytes); */
    /* if(Capacitor.isNativePlatform()){
      return encodeURIComponent(encode(utf8.encode(str)));
    }else{
      return encodeURI(encode(utf8.encode(str)));
    } */
    /* const encoder = new TextEncoder();
    const uint8Array = encoder.encode(str);
    return encodeURIComponent(btoa(String.fromCharCode.apply(null,uint8Array))) */
    const encoder = new TextEncoder();
    const uint8Array = encoder.encode(str);
    return Base64.fromUint8Array(uint8Array, true);
    //return encodeURIComponent(window.btoa(unescape(encodeURIComponent((encode(str)))));
  }

  createParameters(method, sessionToken, data) {
    let parameters = {
      method: method,
      session_token: sessionToken,
      request_id: this.requestId,
      client_hash: this.clientHash,
      client_version: this.clientVersion,
      timestamp: dayjs().format('YYYYMMDDmmssSSS'),
    };
    let testful = TestService.getFailing(method);
    if (testful) {
      data.test = {
        code: testful.code,
        details: testful.details,
        delay: testful.delay
      };
    }
    console.log("createParameters", method, this.requestId);
    console.log("createParameters", method, parameters);
    console.log("createParameters", method, data);
    parameters.data = this.base64urlEncode(JSON.stringify(data));
    return parameters;
  }

  createLanguageFilters(filterLanguages) {
    var languages = [];
    Object.keys(filterLanguages).forEach(function (key) {
      if (filterLanguages[key]) {
        languages.push({
          key: "language_id",
          value: key
        });
      }
    });
    return languages;
  }

  createGenreFilters(filterGenres) {
    var genres = [];
    Object.keys(filterGenres).forEach(function (key) {
      if (filterGenres[key]) {
        genres.push({
          key: "genre_id",
          value: key
        });
      }
    });
    return genres;
  }

  createDecadeFilters(filterDecades) {
    var decades = [];
    Object.keys(filterDecades).forEach(function (key) {
      if (filterDecades[key]) {
        decades.push({
          key: "decade",
          value: key
        });
      }
    });
    return decades;
  }

  createAlphabetFilters(alphabetKey, filterAlphabets) {
    var alphabets = [];
    Object.keys(filterAlphabets).forEach(function (key) {
      if (filterAlphabets[key]) {
        alphabets.push({
          key: alphabetKey,
          value: "^" + key + ".*"
        });
      }
    });
    return alphabets;
  }

  createBrowseParameters(filterLanguages, filterGenres, filterDecades, filterAlphabets, alphabetKey = "title") {
    var items = [];
    var languages = this.createLanguageFilters(filterLanguages);
    var genres = this.createGenreFilters(filterGenres);
    var decades = this.createDecadeFilters(filterDecades);
    var alphabets = this.createAlphabetFilters(alphabetKey, filterAlphabets);
    if (languages.length > 0) {
      items.push([
        ...languages
      ]);
    }
    if (genres.length > 0) {
      items.push([
        ...genres
      ]);
    }
    if (decades.length > 0) {
      items.push([
        ...decades
      ]);
    }
    if (alphabets.length > 0) {
      items.push([
        ...alphabets
      ]);
    }
    return items;
  }

  createMusicParameters(filterLanguages, filterGenres, filterDecades) {
    var items = [];
    var languages = this.createLanguageFilters(filterLanguages);
    var genres = this.createGenreFilters(filterGenres);
    var decades = this.createDecadeFilters(filterDecades);
    if (languages.length > 0) {
      items.push([
        ...languages
      ]);
    }
    if (genres.length > 0) {
      items.push([
        ...genres
      ]);
    }
    if (decades.length > 0) {
      items.push([
        ...decades
      ]);
    }
    items.push([
      {
        key: "media_type",
        value: "music"
      }
    ]);
    return items;
  }

  createPlayListCompactItemList(items) {
    let compactList = [];
    for (let key in items) {
      let item = items[key];
      if (!item.profile.id) {
        console.log("createPlayListCompactItemList", item);
      }
      compactList.push([
        item.track.track_id,
        item.profile.id,
        item.pitch,
        dayjs(item.created).format('YYYY-MM-DD HH:mm:ss'),
        item.played ? dayjs(item.played).format('YYYY-MM-DD HH:mm:ss') : null,
        item.unique_id,
        item.flags
      ]);
    }
    console.log(compactList);
    return compactList;
  }

  async getSHA256Hash(input) {
    const textAsBuffer = new TextEncoder().encode(input);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hash = hashArray
      .map((item) => item.toString(16).padStart(2, "0"))
      .join("");
    return hash;
  };

  sendPost(parameters) {
    let isThrownOut = sessionStore.getState().isThrownOut;
    if (!isThrownOut) {
      if (sessionStore) {
        sessionStore.getState().incRequestCount();
        this.requestId = sessionStore.getState().requestCount;
      }
      return muvika.post('/', parameters);
    } else {
      return new Promise((resolve, reject) => {

        reject();
      });
    }
  }

  sendGet(parameters) {
    let isThrownOut = sessionStore.getState().isThrownOut;
    if (!isThrownOut) {
      if (sessionStore) {
        sessionStore.getState().incRequestCount();
        this.requestId = sessionStore.getState().requestCount;
      }
      console.log(parameters);
      return muvika.get('/', {
        params: parameters
      });
    } else {
      return new Promise((resolve, reject) => {

        reject();
      });
    }
  }

  openSession(language) {
    this.requestCount = 0;
    sessionStore.getState().zeroRequestCount();
    let platformJSON = sessionStorage.getItem(muvikaAttrs.service + "-platform");
    let platform = this.osName;
    if (platformJSON) {
      platform = JSON.parse(platformJSON);
    }
    var sessionParams = {
      api_version: "1.0.6",
      device_id: this.deviceId,
      device_name: this.deviceName,
      device_model: this.deviceModel,
      software_name: this.softwareName,
      software_version: this.softwareVersion,
      os_name: platform,
      os_version: this.osVersion,
      language: language
    };
    console.log("session params", sessionParams)
    var parameters = this.createParameters('session_open', "", sessionParams);
    sessionStore.getState().incRequestCount();
    this.requestId = sessionStore.getState().requestCount;
    return this.sendPost(parameters);
  }

  updateSession(sessionToken, lang, withParams = false) {
    let sessionParams = {
      language: lang
    };
    if (withParams) {
      let platformJSON = sessionStorage.getItem(muvikaAttrs.service + "-platform");
      let platform = this.osName;
      if (platformJSON) {
        platform = JSON.parse(platformJSON);
      }
      sessionParams = {
        api_version: "1.0.6",
        device_id: this.deviceId,
        device_name: this.deviceName,
        device_model: this.deviceModel,
        software_name: this.softwareName,
        software_version: this.softwareVersion,
        os_name: platform,
        os_version: this.osVersion,
        language: lang
      };
    }
    console.log("session params", sessionParams)
    var parameters = this.createParameters('session_update', sessionToken, sessionParams);
    return this.sendPost(parameters);
  }

  closeSession(sessionToken) {
    var parameters = this.createParameters('session_close', sessionToken, {});
    return this.sendPost(parameters);
  }

  login(sessionToken, username, password) {
    username = username.trim();
    password = password.trim();
    var passwordHash = sha256(username.concat(password)).toString();
    var parameters = this.createParameters('account_login', sessionToken, {
      username: username,
      password: passwordHash
    });
    return this.sendPost(parameters);
  }

  oneTimeLogin(sessionToken, username, code) {
    username = username.trim();
    var parameters = this.createParameters('account_login', sessionToken, {
      access_type: "player",
      code: code,
      username: username
    });
    return this.sendPost(parameters);
  }

  songbookLogin(sessionToken, songbookId, captchaId, captchaCode) {
    var parameters = this.createParameters('account_login', sessionToken, {
      access_type: "songbook",
      code: songbookId,
      captcha_id: captchaId,
      captcha_code: captchaCode
    });
    return this.sendPost(parameters);
  }

  logout(sessionToken) {
    var parameters = this.createParameters('account_logout', sessionToken, {});
    return this.sendPost(parameters);
  }

  getLatest(sessionToken, pageSize, page) {
    var parameters = this.createParameters('latest_get', sessionToken, {
      page_size: pageSize,
      page: page
    });
    return this.sendPost(parameters);
  }

  getEnvironment(sessionToken, language) {
    console.log(language);
    var parameters = this.createParameters('environment_get', sessionToken, { language: language });
    return this.sendPost(parameters);
  }

  getTracks(sessionToken, pageSize, page, items, orderBy) {
    let searchParamters = items;
    if (items.length == 0) {
      searchParamters = [
        [
          {
            key: "title",
            value: "^.*"
          }
        ]
      ];
    }
    var parameters = this.createParameters('track_browse', sessionToken, {
      page_size: pageSize,
      page: page,
      sort_by: orderBy,
      items: searchParamters
    });
    console.log(orderBy);
    return this.sendPost(parameters);
  }

  search(sessionToken, pageSize, page, query, fieldTitle, fieldArtist) {
    let fields = "";
    if (fieldTitle) {
      fields += "title";
    }
    if (fieldArtist) {
      fields += fields.length == 0 ? "" : " ";
      fields += "artist";
    }
    var parameters = this.createParameters('track_search', sessionToken, {
      fields: fields,
      query: query,
      page_size: pageSize,
      page: page
    });
    return this.sendPost(parameters);
  }

  musicSearch(sessionToken, pageSize, page, query, fieldTitle, fieldArtist) {
    let fields = "";
    if (fieldTitle) {
      fields += "title";
    }
    if (fieldArtist) {
      fields += fields.length == 0 ? "" : " ";
      fields += "artist";
    }
    var parameters = this.createParameters('track_search', sessionToken, {
      fields: fields,
      query: query,
      page_size: pageSize,
      page: page,
      media_type: "music"
    });
    return this.sendPost(parameters);
  }

  checkIfBeforeNow(dateStr) {
    var now = new Date();
    now.setMinutes(now.getMinutes() + Math.round(accountStore.getState().timeDiff));
    var date = new Date(dateStr);
    return date < now;
  };

  getStreamUrl(sessionToken, trackId, pitch, version, isPreview = false) {
    let account = accountStore.getState().account;
    console.log(account);
    if (account) {
      if (account.subscription.valid == 1) {
        let params = {
          track_id: trackId,
          pitch: pitch,
          version: version,
        };
        if (isPreview) {
          params.flags = ["with_preview"];
        }
        var parameters = this.createParameters('stream_url_get', sessionToken, params);
        return this.sendPost(parameters);
      }
    }
    return new Promise((resolve, reject) => {


      reject();
    });
  }

  getFavorites(sessionToken, pageSize, page, items) {
    var parameters = this.createParameters('favorites_get', sessionToken, {
      page_size: pageSize,
      page: page,
    });
    return this.sendPost(parameters);
  }

  setFavorite(sessionToken, trackId) {
    var parameters = this.createParameters('favorites_set', sessionToken, {
      track_id: trackId
    });
    return this.sendPost(parameters);
  }

  deleteFavorite(sessionToken, trackId) {
    var parameters = this.createParameters('favorites_delete', sessionToken, {
      track_id: trackId
    });
    return this.sendPost(parameters);
  }

  getSingers(sessionToken, pageSize, page) {
    var parameters = this.createParameters('profiles_get', sessionToken, {
      page_size: pageSize,
      page: page,
    });
    return this.sendPost(parameters);
  }

  createSinger(sessionToken, name, gender, email) {
    let dateNow = new Date();
    dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
    var parameters = this.createParameters('profiles_create', sessionToken, {
      name: name,
      gender: gender,
      created: dateNow,
      email: email
    });
    return this.sendPost(parameters);
  }

  deleteSinger(sessionToken, profileId) {
    var parameters = this.createParameters('profiles_delete', sessionToken, {
      profile_id: profileId
    });
    return this.sendPost(parameters);
  }

  getLastPerformance(sessionToken, trackId) {
    var parameters = this.createParameters('last_performance_get', sessionToken, {
      track_id: trackId
    });
    return this.sendPost(parameters);
  }

  editSinger(sessionToken, profileId, name, gender, email) {
    let dateNow = new Date();
    dateNow.setMinutes(dateNow.getMinutes() + Math.round(accountStore.getState().timeDiff));
    var parameters = this.createParameters('profiles_update', sessionToken, {
      id: profileId,
      name: name,
      gender: gender,
      created: dateNow,
      email: email
    });
    return this.sendPost(parameters);
  }

  getMusicPlayLists(sessionToken) {
    var parameters = this.createParameters('playlists_get', sessionToken, {
      category: "music",
      form: "list"
    });
    return this.sendPost(parameters);
  }

  createMusicPlayList(sessionToken, name) {
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "normal",
      category: "music",
      form: "list",
      id: 0,
      name: name,
      items: []
    });
    return this.sendPost(parameters);
  }

  saveMusicFilter(sessionToken, filter) {
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "normal",
      category: "music",
      form: "criteria",
      id: filter.id,
      name: filter.name,
      criteria: filter.criteria,
    });
    return this.sendPost(parameters);
  }

  createMusicFilter(sessionToken, filter) {
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "normal",
      category: "music",
      form: "criteria",
      id: 0,
      name: filter.name,
      criteria: filter.criteria,
    });
    return this.sendPost(parameters);
  }

  getMusicFilters(sessionToken) {
    var parameters = this.createParameters('playlists_get', sessionToken, {
      category: "music",
      form: "criteria",
      flags: ""
    });
    return this.sendPost(parameters);
  }

  getPlayLists(sessionToken) {
    var parameters = this.createParameters('playlists_get', sessionToken, {
      flags: ""
    });
    return this.sendPost(parameters);
  }

  createPlayList(sessionToken, name) {
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "normal",
      category: "karaoke",
      id: 0,
      name: name,
      items: []
    });
    return this.sendPost(parameters);
  }

  saveMusicPlayQueue(sessionToken, name, performances) {
    let compactItemList = this.createPlayListCompactItemList(performances);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "normal",
      category: "music",
      id: 0,
      name: name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  savePlayQueue(sessionToken, name, performances) {
    let compactItemList = this.createPlayListCompactItemList(performances);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "normal",
      category: "karaoke",
      id: 0,
      name: name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  savePlayList(sessionToken, id, name, performances) {
    let compactItemList = this.createPlayListCompactItemList(performances);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "normal",
      category: "music",
      id: id,
      name: name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  savePlayList(sessionToken, id, name, performances) {
    let compactItemList = this.createPlayListCompactItemList(performances);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "normal",
      category: "karaoke",
      id: id,
      name: name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  editMusicPlayList(sessionToken, name, playList) {
    let compactItemList = this.createPlayListCompactItemList(playList.items);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: playList.type,
      category: "music",
      id: playList.id,
      name: name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  editPlayList(sessionToken, name, playList) {
    let compactItemList = this.createPlayListCompactItemList(playList.items);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: playList.type,
      category: "karaoke",
      id: playList.id,
      name: name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  deleteMusicPlayList(sessionToken, playListId) {
    var parameters = this.createParameters('playlist_delete', sessionToken, {
      id: playListId,
      category: "music"
    });
    return this.sendPost(parameters);
  }

  deletePlayList(sessionToken, playListId) {
    var parameters = this.createParameters('playlist_delete', sessionToken, {
      id: playListId,
    });
    return this.sendPost(parameters);
  }

  setMusicList(sessionToken, items, criteria) {
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "playqueue",
      category: "music",
      form: "criteria",
      items: items,
      criteria: criteria
    });
    return this.sendPost(parameters);
  }

  setMusicFilter(sessionToken, filter) {
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "normal",
      category: "music",
      form: "criteria",
      criteria: filter.criteria,
      id: filter.id,
      name: filter.name,
    });
    return this.sendPost(parameters);
  }

  setMusicPlayList(sessionToken, playList) {
    console.log("playlist_set", playList);
    let compactItemList = this.createPlayListCompactItemList(playList.items);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: playList.type,
      category: "music",
      id: playList.id,
      name: playList.name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  setPlayList(sessionToken, playList) {
    let compactItemList = this.createPlayListCompactItemList(playList.items);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: playList.type,
      category: playList.category,
      id: playList.id,
      name: playList.name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  setMusicHistory(sessionToken, history) {
    let compactItemList = this.createPlayListCompactItemList(history.items);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "history",
      category: "music",
      id: history.id,
      name: history.name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  setHistory(sessionToken, history) {
    let compactItemList = this.createPlayListCompactItemList(history.items);
    var parameters = this.createParameters('playlist_set', sessionToken, {
      type: "history",
      category: history.category,
      id: history.id,
      name: history.name,
      items: compactItemList
    });
    return this.sendPost(parameters);
  }

  getMusicList(sessionToken) {
    var parameters = this.createParameters('playlist_get', sessionToken, {
      type: "playqueue",
      category: "music",
      form: "list"
    });
    return this.sendPost(parameters);
  }

  getMusicPlayList(sessionToken, playList) {
    var parameters = this.createParameters('playlist_get', sessionToken, {
      id: playList.id,
      type: playList.type,
      category: "music",
      form: "list"
    });
    return this.sendPost(parameters);
  }

  getPlayList(sessionToken, playList) {
    var parameters = this.createParameters('playlist_get', sessionToken, {
      id: playList.id,
      type: playList.type,
      category: "karaoke"
    });
    return this.sendPost(parameters);
  }

  getMusicPlayQueue(sessionToken) {
    var parameters = this.createParameters('playlist_get', sessionToken, {
      type: "playqueue",
      category: "music"
    });
    return this.sendPost(parameters);
  }

  getPlayQueue(sessionToken) {
    var parameters = this.createParameters('playlist_get', sessionToken, {
      type: "playqueue",
      category: "karaoke"
    });
    return this.sendPost(parameters);
  }

  getHistory(sessionToken) {
    var parameters = this.createParameters('playlist_get', sessionToken, {
      type: "history",
      category: "karaoke"
    });
    return this.sendPost(parameters);
  }

  getMusicHistory(sessionToken) {
    var parameters = this.createParameters('playlist_get', sessionToken, {
      type: "history",
      category: "music"
    });
    return this.sendPost(parameters);
  }

  getSettings(sessionToken) {
    var parameters = this.createParameters('settings_get', sessionToken, {});
    return this.sendPost(parameters);
  }

  setSettings(sessionToken, settings) {
    var parameters = this.createParameters('settings_set', sessionToken, settings);
    return this.sendPost(parameters);
  }

  getAccount(sessionToken) {
    var parameters = this.createParameters('account_get', sessionToken, {});
    return this.sendPost(parameters);
  }

  setAccount(sessionToken, account) {
    var parameters = this.createParameters('account_update', sessionToken, account);
    return this.sendPost(parameters);
  }

  async createAccount(sessionToken, account, verificationCode) {
    let passwordHash = sha256(account.username.concat(account.password)).toString();
    account.password = passwordHash;
    account.code = verificationCode;
    var parameters = this.createParameters('account_create', sessionToken, account);
    return this.sendPost(parameters);
  }

  async changePassword(sessionToken, email, oldPassword, newPassword) {
    email = email.trim();
    oldPassword = oldPassword.trim();
    newPassword = newPassword.trim();
    let oldPasswordHash = sha256(email.concat(oldPassword)).toString();
    let newPasswordHash = sha256(email.concat(newPassword)).toString();
    var parameters = this.createParameters('account_password_update', sessionToken, {
      old_password: oldPasswordHash,
      password: newPasswordHash
    });
    return this.sendPost(parameters);
  }

  async changeForgottenPassword(sessionToken, email, newPassword, verificationCode) {
    email = email.trim();
    newPassword = newPassword.trim();
    let newPasswordHash = sha256(email.concat(newPassword)).toString();
    var parameters = this.createParameters('password_change', sessionToken, {
      password: newPasswordHash,
      code: verificationCode
    });
    return this.sendPost(parameters);
  }

  async changeUsername(sessionToken, newUsername, password, verificationCode) {
    newUsername = newUsername.trim();
    password = password.trim();
    let passwordHash = sha256(newUsername.concat(password)).toString();
    var parameters = this.createParameters('username_change', sessionToken, {
      code: verificationCode,
      username: newUsername,
      password: passwordHash
    });
    return this.sendPost(parameters);
  }

  createAccountLink(sessionToken, email, reason) {
    email = email.trim();
    var parameters = this.createParameters('account_link_create', sessionToken, {
      reason: reason,
      username: email
    });
    return this.sendPost(parameters);
  }

  verifyAccountLink(sessionToken, verificationCode) {
    var parameters = this.createParameters('account_link_verify', sessionToken, {
      reason: "create_account",
      code: verificationCode
    });
    return this.sendPost(parameters);
  }

  createAccountPin(sessionToken, email, reason, captchaId, captchaCode, password, currentUsername, source, license) {
    let passwordHash = null;
    if (password) {
      password = password.trim();
      passwordHash = sha256(currentUsername.concat(password)).toString();
    }
    email = email.trim();
    var parameters = this.createParameters('account_pin_create', sessionToken, {
      reason: reason,
      username: email,
      captcha_id: captchaId,
      captcha_code: captchaCode,
      password: passwordHash,
      source: source,
      license: license
    });
    return this.sendPost(parameters);
  }

  verifyAccountPin(sessionToken, pin, email, reason) {
    email = email.trim();
    var parameters = this.createParameters('account_pin_verify', sessionToken, {
      reason: reason,
      username: email,
      pin: pin
    });
    return this.sendPost(parameters);
  }

  setTrackRating(sessionToken, trackId, rating) {
    var parameters = this.createParameters('track_rating_set', sessionToken, {
      track_id: trackId,
      rating: rating
    });
    return this.sendPost(parameters);
  }

  getNews(sessionToken, pageSize, page) {
    var parameters = this.createParameters('news_get', sessionToken, {
      page_size: pageSize,
      page: page,
    });
    return this.sendPost(parameters);
  }

  getTracksForMusic(sessionToken, pageSize, page, items, orderBy) {
    var parameters = this.createParameters('track_browse', sessionToken, {
      page_size: pageSize,
      page: page,
      sort_by: orderBy,
      items: items
    });
    return this.sendPost(parameters);
  }

  setTrackLog(sessionToken, track, pitch, profileId, screenType) {
    const d = new Date();
    const date = d.toISOString().split('T')[0];
    const time = d.toTimeString().split(' ')[0];
    var parameters = this.createParameters('track_log_set', sessionToken, {
      items:
        [
          {
            track_id: track.track_id,
            screen_type: screenType,
            profile_id: profileId,
            time_played: `${date} ${time}`,
            playback_type: "stream",
            pitch: pitch
          }
        ]
    });
    console.log("sending track log", {
      track_id: track.track_id,
      screen_type: screenType,
      profile_id: profileId,
      time_played: `${date} ${time}`,
      playback_type: "stream",
      pitch: pitch
    }
    );
    return this.sendPost(parameters);
  }

  sendFeedback(sessionToken, type, description, title=null, artist=null) {
    var parameters = this.createParameters('feedback', sessionToken, {
      type: type,
      title: title,
      artist: artist,
      desc: description
    });
    return this.sendPost(parameters);
  }

  getSongbookRequests(sessionToken) {
    var parameters = this.createParameters('song_requests_get', sessionToken, {});
    return this.sendPost(parameters);
  }

  cancelSubscription(sessionToken, orderId) {
    var parameters = this.createParameters('subscription_cancel', sessionToken, {
      order_id: orderId,
      flags: ""
    });
    return this.sendPost(parameters);
  }

  ackSongbookRequest(sessionToken, items, uniqueIds) {
    var parameters = this.createParameters('song_requests_ack', sessionToken, {
      items: items,
      unique_ids: uniqueIds
    });
    return this.sendPost(parameters);
  }

  createSongRequest(sessionToken, reqType, trackId, profileId, pitch, uniqueIds, flags) {
    var parameters = this.createParameters('song_request_create', sessionToken, {
      req_type: reqType,
      track_id: trackId,
      profile_id: profileId,
      pitch: pitch,
      unique_ids: uniqueIds,
      flags: flags
    });
    return this.sendPost(parameters);
  }

  getMySongRequests(sessionToken, type) {
    var parameters = this.createParameters('my_song_requests_get', sessionToken, {
      type: type
    });
    return this.sendPost(parameters);
  }

  getTrackCreators(sessionToken, trackId) {
    var parameters = this.createParameters('track_creators_get', sessionToken, {
      track_id: trackId
    });
    return this.sendPost(parameters);
  }

  statusReport(sessionToken, appStatus, playerStatus) {
    var parameters = this.createParameters('status', sessionToken, {
      app_status: appStatus,
      player_status: playerStatus
    });
    return this.sendPost(parameters);
  }

  getTop(sessionToken, pageSize, page) {
    var parameters = this.createParameters('top_get', sessionToken, {
      page_size: pageSize,
      page: page
    });
    return this.sendPost(parameters);
  }

  getPublicPlaylists(sessionToken) {
    var parameters = this.createParameters('public_playlists_get', sessionToken, {
    });
    return this.sendPost(parameters);
  }

  createCaptcha(sessionToken) {
    var parameters = this.createParameters('captcha_create', sessionToken, {
    });
    return this.sendPost(parameters);
  }

  searchSuggest(sessionToken, query, fieldTitle, fieldArtist) {
    let fields = "";
    if (fieldTitle) {
      fields += "title";
    }
    if (fieldArtist) {
      fields += fields.length == 0 ? "" : " ";
      fields += "artist";
    }
    var parameters = this.createParameters('track_suggest', sessionToken, {
      fields: fields,
      query: query,
      media_type: "karaoke"
    });
    return this.sendPost(parameters);
  }

  searchMusicSuggest(sessionToken, query, fieldTitle, fieldArtist) {
    let fields = "";
    if (fieldTitle) {
      fields += "title";
    }
    if (fieldArtist) {
      fields += fields.length == 0 ? "" : " ";
      fields += "artist";
    }
    var parameters = this.createParameters('track_suggest', sessionToken, {
      fields: fields,
      query: query,
      media_type: "music"
    });
    return this.sendPost(parameters);
  }

  deleteAccount(sessionToken, email, password) {
    let passwordHash = null;
    if (password) {
      password = password.trim();
      passwordHash = sha256(email.concat(password)).toString();
    }
    var parameters = this.createParameters('account_delete', sessionToken, {
      password: passwordHash
    });
    return this.sendPost(parameters);
  }
}

export default new MuvikaService();